import BaseTag from '@deprecated-ui/common/Tag';
import color from '@deprecated-ui/_style/color';

const { Tag } = BaseTag;

function LabelSuspended() {
  return (
    <Tag
      style={{
        borderColor: color.sunsetOrange,
        color: color.sunsetOrange,
        fontWeight: 'bold',
      }}
    >
      Suspended
    </Tag>
  );
}

export default LabelSuspended;
